/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_viewer">;
    readonly " $refType": "PdpRespSidebarButtons_viewer";
};
export type PdpRespSidebarButtons_viewer$data = PdpRespSidebarButtons_viewer;
export type PdpRespSidebarButtons_viewer$key = {
    readonly " $data"?: PdpRespSidebarButtons_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarButtons_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '23c2f46402cb6857e0d881f5d34fc5d0';
export default node;
